import apiClient from "../../api/apiClient";

const dataOf = (response) => response?.data || {};

export async function listTaxes({ companyId, page = 1, limit = 20, search = "" }) {
  const data = dataOf(await apiClient.get("/api/taxes", { params: { companyId, page, limit, search: search || undefined } }));
  return { rows: data.taxes || [], total: Number(data.pagination?.totalItems || 0) };
}
export async function saveTax(id, payload) {
  return id ? apiClient.put(`/api/taxes/${id}`, payload) : apiClient.post("/api/taxes", payload);
}
export async function deleteTax(id) { return apiClient.delete(`/api/taxes/${id}`); }
export async function toggleTax(id, status) { return apiClient.patch(`/api/taxes/${id}/status`, { status }); }

export async function listCurrencies({ companyId, page = 1, limit = 20, search = "" }) {
  const data = dataOf(await apiClient.get("/api/currencies", { params: { companyId, page, limit, search: search || undefined } }));
  return { rows: data.currencies || [], total: Number(data.pagination?.totalItems || 0) };
}
export async function saveCurrency(id, payload) {
  return id ? apiClient.put(`/api/currencies/${id}`, payload) : apiClient.post("/api/currencies", payload);
}
export async function deleteCurrency(id) { return apiClient.delete(`/api/currencies/${id}`); }

export async function listPaymentModes({ companyId, page = 1, limit = 20, search = "", filterCompany = true }) {
  const data = dataOf(await apiClient.get("/api/payment-modes", {
    params: { page, limit, search: search || undefined, company_id: filterCompany ? companyId : undefined },
  }));
  return { rows: data.paymentModes || [], total: Number(data.pagination?.totalItems || 0) };
}
export async function savePaymentMode(id, payload) {
  return id ? apiClient.put(`/api/payment-modes/${id}`, payload) : apiClient.post("/api/payment-modes", payload);
}
export async function deletePaymentMode(id) { return apiClient.delete(`/api/payment-modes/${id}`); }

export async function listCompanies(page = 1, status = "active") {
  const data = dataOf(await apiClient.get("/api/companies", { params: { page, status } }));
  return { rows: data.companies || [], pages: Number(data.pagination?.totalPages || 1) };
}
export async function listCompaniesForModals(status) {
  const data = dataOf(await apiClient.get("/api/companies/for-modals", {
    params: status ? { status } : undefined,
  }));
  return data.companies || [];
}
export async function listCompanyCurrencies(companyId) {
  const data = dataOf(await apiClient.get("/api/currencies", { params: { companyId, limit: 1000 } }));
  return data.currencies || [];
}
export async function saveCompany(id, formData) {
  const options = { headers: { "Content-Type": "multipart/form-data" } };
  return id ? apiClient.put(`/api/companies/${id}`, formData, options) : apiClient.post("/api/companies", formData, options);
}
export async function deleteCompany(id) { return apiClient.delete(`/api/companies/${id}`); }
export async function toggleCompany(id, status) { return apiClient.patch(`/api/companies/${id}/status`, { status }); }

export async function listStaff({ companyId, page = 1, limit = 20, search = "", status }) {
  const data = dataOf(await apiClient.get("/api/users", { params: {
    companyId, page, limit, search: search || undefined,
    status: status && status !== "all" ? status : undefined,
    user_type: "staff_members",
  } }));
  return { rows: data.users || [], total: Number(data.pagination?.totalItems || 0) };
}
export async function getStaff(id) { return dataOf(await apiClient.get(`/api/users/${id}`)); }
export async function suggestStaffUsername(name) {
  const data = dataOf(await apiClient.get("/api/users/username-suggestion", {
    params: { name },
  }));
  return data.username || "";
}
export async function saveStaff(id, formData) {
  const options = { headers: { "Content-Type": "multipart/form-data" } };
  return id ? apiClient.put(`/api/users/${id}`, formData, options) : apiClient.post("/api/users", formData, options);
}
export async function saveStaffCompanyRoles(id, companyId, roleIds) {
  return apiClient.put(`/api/users/${id}/company-roles/${companyId}`, { role_ids: roleIds }, {
    headers: { "X-Company-Id": String(companyId) },
  });
}
export async function deleteStaff(id) { return apiClient.delete(`/api/users/${id}`); }

export async function listWarehouses(companyId, page = 1) {
  const data = dataOf(await apiClient.get("/api/warehouses", {
    params: { company_id: companyId, page },
    headers: { "X-Company-Id": String(companyId) },
  }));
  return { rows: data.warehouses || [], pages: Number(data.pagination?.totalPages || 1) };
}
export async function saveWarehouse(id, formData) {
  const options = { headers: { "Content-Type": "multipart/form-data" } };
  return id ? apiClient.put(`/api/warehouses/${id}`, formData, options) : apiClient.post("/api/warehouses", formData, options);
}
export async function deleteWarehouse(id) { return apiClient.delete(`/api/warehouses/${id}`); }
export async function toggleWarehouse(id, status) { return apiClient.patch(`/api/warehouses/${id}/status`, { status }); }
export async function getWarehousePosRoutes(id) {
  return dataOf(await apiClient.get(`/api/warehouses/${id}/pos-payment-routes`, { params: { include_options: true } }));
}
export async function saveWarehousePosRoutes(id, routes) {
  return apiClient.put(`/api/warehouses/${id}/pos-payment-routes`, { routes });
}

export async function listRoles(companyId) {
  const data = dataOf(await apiClient.get("/api/roles", {
    params: companyId ? { company_id: companyId } : {},
    ...(companyId ? { headers: { "X-Company-Id": String(companyId) } } : {}),
  }));
  return data.roles || [];
}
export async function listPermissions() {
  const data = dataOf(await apiClient.get("/api/permissions"));
  return Array.isArray(data.permissions) ? data.permissions : Array.isArray(data) ? data : [];
}
export async function getRolePermissions(id) {
  const data = dataOf(await apiClient.get(`/api/roles/${id}/permissions`));
  return data.permissions || [];
}
export async function saveRole(id, name, companyId) {
  if (id) return apiClient.put(`/api/roles/${id}`, { name }, { params: { company_id: companyId || undefined } });
  const response = await apiClient.post("/api/roles", { name, company_id: companyId || undefined });
  return response.data;
}
export async function duplicateRole(id, name, companyId) {
  const response = await apiClient.post(`/api/roles/${id}/duplicate`, {
    name,
    company_id: companyId || undefined,
  });
  return response.data;
}
export async function deleteRole(id, companyId) { return apiClient.delete(`/api/roles/${id}`, { params: { company_id: companyId || undefined } }); }
export async function saveRolePermissions(id, permissions) {
  await apiClient.put(`/api/roles/${id}/permissions`, { permissions });
  try { await apiClient.post("/api/roles/notify-changes", { role_id: id }); } catch { /* notification non bloquante */ }
}
